import React, { useEffect } from "react";
import { ConnectedProps, connect } from "react-redux";
import {
  actions as pendingUserActions,
  pickersSelector as pendingUserSelectors,
} from "reducers/pickers";
import { FilterPickers as FilterPickersCO } from "pages/pickers/filter/CO/FilterCO";
import { FilterPickers as FilterPickersAR } from "pages/pickers/filter/AR/FilterAR";
import { FilterPickers as FilterPickersMX } from "pages/pickers/filter/MX/FilterMX";
import { FilterPickers as FilterPickersCL } from "pages/pickers/filter/CL/FilterCL";
import { ParamsMiddlewareType, PickersParamsType } from "../types";
import { FilterContainerTypes } from "./types";
import { AppDispatch, RootState } from "store";
import { sessionSelector } from "reducers/session";
import { DEFAULT_COUNTRY } from "hooks/useSession";
import { CountryComponentType } from "utils/types";
import useBasicData, { BasicDataItemsType } from "hooks/useBasicData";
import { CountryCodeType } from "reducers/types/session";
import { ACTIVE_PICKER_STATUS } from "utils/constants";

const basicCountryData: { [key in CountryCodeType]: BasicDataItemsType[] } = {
  AR: ["regions"],
  CO: ["identifications", "regions"],
  MX: ["regions"],
  CL: ["regions"],
};

const FilterPickersContainer = (
  props: FilterContainerTypes & ConnectorProps
) => {
  const { identifications, regions } = useBasicData(
    basicCountryData[props.countryCode]
  );

  useEffect(() => {
    if (props.filters && Object.keys(props.filters).length === 0) {
      props.reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.filters]);

  const search = (values: PickersParamsType) => {
    props.getPendingUser({
      ...values,
      ...props.filtersExtra,
      identificationType: values?.identificationType?.tag,
      vehicleType: values.vehicleType || undefined,
      status: values.status || ACTIVE_PICKER_STATUS.join(","),
    });
    props.setPendingUserFilters(values);
  };

  const filter: CountryComponentType = {
    AR: <FilterPickersAR {...props} onSubmit={search} regions={regions} />,
    CO: (
      <FilterPickersCO
        {...props}
        onSubmit={search}
        regions={regions}
        identificationType={identifications}
      />
    ),
    MX: <FilterPickersMX {...props} onSubmit={search} regions={regions} />,
    CL: <FilterPickersCL {...props} onSubmit={search} regions={regions} />,
  };

  return <>{filter[props.countryCode as CountryCodeType]}</>;
};

const mapStateToProps = (state: RootState) => ({
  filters: pendingUserSelectors(state).filters,
  filtersExtra: pendingUserSelectors(state).filtersExtra,
  countryCode: sessionSelector(state).countryCode || DEFAULT_COUNTRY,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  reset: () => {
    dispatch(pendingUserActions.reset());
  },
  setPendingUserFilters: (filters: PickersParamsType) => {
    dispatch(pendingUserActions.setPendingUserFilters(filters));
  },
  getPendingUser: (params: ParamsMiddlewareType) => {
    dispatch(pendingUserActions.getPendingUserRequest(params));
  },
  setCollapseTable: (collapse: boolean) => {
    dispatch(pendingUserActions.setCollapseTable(collapse));
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connector(FilterPickersContainer);
